const Aggregates = {};
export default Aggregates;
